export function toPlainDesc(html, length = 100) {
  if (!html) { return; }
  const d = document.createElement('div');
  d.innerHTML = html;
  return d.innerText.replaceAll('\n', ' ').slice(0, length).trim();
}
